import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import Message from "../Message/Message";

const ChatWindow: React.FC = () => {
    const messages = useSelector((state: RootState) => state.chat.messages)
    const lastmessageRef = useRef<HTMLDivElement | null>(null)
    const typingMessage = useSelector((state: RootState) => state.chat.typingMessage)

    useEffect(() => {
        if (lastmessageRef.current) {
            lastmessageRef.current.scrollIntoView({ behavior: 'smooth' })
        }
    }, [messages, typingMessage])

    return (
        <div className="chat-window">
            <div className="chat-messages">
                {
                    messages.map((msg, index) => (
                        <Message key={index}
                            message={{ 'message': msg.message, 'msgDateTime': msg.msgDateTime, 'sender': msg.sender, currentModule: 'idm', files: msg.files, fileUploadedTime: msg.fileUploadedTime, ResMsgDateTime: msg.ResMsgDateTime }}
                            ref={(index === messages.length - 1) ? lastmessageRef : null}
                        />
                    ))
                }
                {typingMessage && <Message message={typingMessage} ref={lastmessageRef} />}
            </div>
        </div>
    )
}

export default ChatWindow